/**
 * Capacitor platform helpers.
 *
 * `window.Capacitor` is injected by the Capacitor runtime when the bundle is
 * executed inside the Android (or iOS) wrapper. On the regular web, the global
 * is undefined and these helpers fall back to safe defaults.
 *
 * We avoid importing `@capacitor/core` directly here because that would force
 * every web build to ship the Capacitor SDK. The runtime injects `window.Capacitor`
 * before any React code runs, so a tiny duck-typed read is enough.
 */
export function isNativePlatform() {
  try {
    return !!(typeof window !== "undefined" && window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());
  } catch {
    return false;
  }
}

export function getPlatform() {
  try {
    if (typeof window !== "undefined" && window.Capacitor && window.Capacitor.getPlatform) {
      return window.Capacitor.getPlatform();
    }
  } catch {/* no-op */}
  return "web";
}
